import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';

@Component({
  selector: 'app-review-policy',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './review-policy.component.html',
  styleUrl: './review-policy.component.scss',
})
export class ReviewPolicyComponent {
  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle('Review of Policy Terms | World2Cover');
    this.metaService.updateTag({
      name: 'description',
      content:
        'Learn how World2Cover reviews its travel insurance policies to ensure transparency and fair terms, with updates on cover for existing medical conditions.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Review of Policy Terms | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'Learn how World2Cover reviews its travel insurance policies to ensure transparency and fair terms, with updates on cover for existing medical conditions.',
    });
  }
}
